import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({
  breakpoints,
  palette,
  fontSizes,
  fontWeights,
  siteMaxWidth,
}: Theme) => ({
  root: {
    backgroundColor: palette.common.black,
    position: 'relative',
    overflow: 'hidden',
    width: '100%',
    height: 'calc(100vh - 5rem)',
    maxHeight: 'fit-content',
    overflowY: 'hidden',
    lineHeight: 0.6,
    '& .MuiTabs-root': {
      position: 'absolute',
      bottom: '2rem',
      left: '50%',
      transform: 'translateX(-50%)',
      zIndex: 4,
      minHeight: 'unset',
      padding: 2,
      borderRadius: '2rem',
      background: palette.common.white,
      boxShadow: '3px 4px 13px 0 rgba(5, 41, 103, 0.1)',
    },
    '& .MuiTabs-scroller': {
      height: 'min-content',
    },
    '& .MuiTab-fullWidth': {
      minHeight: 'unset',
      padding: '0.5rem 1.5rem',
      borderRadius: '2.5rem',
      color: palette.text.primary,
      fontSize: fontSizes.sm,
      fontWeight: fontWeights.regular,
      lineHeight: 1,
      textTransform: 'none',
      opacity: 1,
      [breakpoints.up('md')]: {
        width: '11.5rem',
      },
      '&.Mui-selected': {
        background: palette.primary.dark,
        color: palette.common.white,
      },
    },
    '& .MuiTabs-indicator': {
      display: 'none',
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.75rem',
    width: '100%',
    borderRadius: '0.375rem',
    [breakpoints.up('md')]: {
      width: 'auto',
      height: '100%',
    },
  },
  wrapper: {
    width: '100%',
  },

  imageWrapper: {
    position: 'relative',
    width: '100%',
    maxWidth: '1440px',
    margin: '0 auto',
    overflow: 'hidden',
    backgroundColor: palette.common.white,
    minHeight: '500px',
    '@media (orientation: landscape) and (max-width: 1180px)': {
      height: '100vh',
      backgroundColor: palette.common.black,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: 0,
      margin: 0,
    },
  },

  baseImage: {
    display: 'block',
    maxWidth: siteMaxWidth,
    height: 'auto',
    margin: '0 auto',
    objectFit: 'contain',
    width: '100%',
    pointerEvents: 'none',
    '@media (orientation: landscape) and (max-width: 1180px)': {
      width: 'auto',
      height: '100%',
    },
  },

  maskedBlur: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    maxWidth: siteMaxWidth,
    zIndex: 2,
    overflow: 'hidden',
    pointerEvents: 'none',
    WebkitMaskRepeat: 'no-repeat',
    maskRepeat: 'no-repeat',
    '@media (orientation: landscape)': {
      maxWidth: siteMaxWidth,
      backgroundColor: palette.common.black,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  },

  blurImage: {
    width: '100%',
    height: 'auto',
    display: 'block',
    position: 'absolute',
    maxWidth: siteMaxWidth,
    top: 0,
    left: 0,
    zIndex: 1,
    pointerEvents: 'none',
    '@media (orientation: landscape)': {
      maxWidth: '100%',
      height: 'auto',
      maxHeight: '100%',
      objectFit: 'contain',
      left: '50%',
      transform: 'translateX(-50%)',
    },
  },

  panelInner: {
    display: 'flex',
  },
  list: {
    listStyle: 'none',
    padding: 0,
    margin: 0,
  },
  draggableCircle: {
    width: 150,
    height: 150,
    borderRadius: '50%',
    border: `2px solid ${palette.common.white}`,
    position: 'absolute',
    top: 0,
    left: 0,
    cursor: 'grab',
    zIndex: 3,
    backgroundColor: 'transparent',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
    pointerEvents: 'none',
    [breakpoints.down('sm')]: {
      width: 200,
      height: 200,
    },
    [breakpoints.up('lg')]: {
      width: 300,
      height: 300,
    },
  },

  dragging: {
    cursor: 'grabbing',
  },

  clickOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 0,
    pointerEvents: 'auto',
  },
}));
